import { Select as MuiSelect, InputLabel, FormControl } from '@mui/material';

export default function Select({
  id,
  label,
  value,
  children,
  error,
  name,
  open,
  renderValue,
  displayEmpty,
  MenuProps,
  onChange,
  onOpen,
  onClose,
  sx,
  style,
}) {
  return (
    <FormControl variant="standard" sx={sx}>
      {label ? (
        <InputLabel shrink htmlFor={id}>
          {label}
        </InputLabel>
      ) : null}

      <MuiSelect
        native={false}
        multiple={true}
        id={id}
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        name={name}
        value={value}
        error={error}
        onChange={onChange}
        renderValue={renderValue}
        MenuProps={MenuProps}
        displayEmpty={displayEmpty}
        style={style}
      >
        {children}
      </MuiSelect>
    </FormControl>
  );
}
